import './App.css';
import Dictionary from "./Dictionary";


export default function App() {
  return (
    <div className="App">
      <div className='container'>
        <header className='App-header'></header>
<main>
<Dictionary defaultKeyword="sky"/>
  </main>    
      <footer className="App-footer">
        <small>Coded by Kate Holota</small>
            </footer>
    </div>
   </div>
  );
}
